import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, finalize, of, take } from 'rxjs';

import { GlobalFunctionsService } from './global-functions.service';

interface AppVersionResponse {
  required_build?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {
  private checkInFlight = false;
  private logoutTriggered = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private gfunc: GlobalFunctionsService
  ) {}

  checkForVersionMismatch(): void {
    const currentUser = sessionStorage.getItem('currentUser');

    if (!currentUser) {
      this.logoutTriggered = false;
      return;
    }

    if (this.checkInFlight || this.logoutTriggered) {
      return;
    }

    this.checkInFlight = true;
    const params = new HttpParams().set('_ts', Date.now().toString());

    this.http
      .get<AppVersionResponse>(this.gfunc.apiURL + '/api/app/version', { params })
      .pipe(
        take(1),
        catchError((error) => {
          console.error('App version check failed', error);
          return of(null);
        }),
        finalize(() => {
          this.checkInFlight = false;
        })
      )
      .subscribe((response: AppVersionResponse | null) => {
        const serverBuild = (response?.required_build || '').trim();
        const clientBuild = (this.gfunc.app_build || '').trim();

        if (!serverBuild || !clientBuild || serverBuild === clientBuild) {
          return;
        }

        this.logoutTriggered = true;

        this.router.navigate(['/logout'], {
          queryParams: {
            reason: 'version-mismatch',
            clientBuild,
            serverBuild
          }
        });
      });
  }
}
